// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { sync } from 'vuex-router-sync'
import vuexI18n from 'vuex-i18n'
import store from './store'
import VueFire from 'vuefire'
// import './firebase'
import {db} from './firebase'
import Firebase from 'firebase'
import translationsEn from './i18n/en.json'
import translationsFr from './i18n/fr.json'
import Vue2Leaflet from 'vue2-leaflet'
import VuePaginate from 'vue-paginate'

Vue.use(VuePaginate)

export const AWS = require('aws-sdk')
AWS.config.update({
  accessKeyId: 'AKIAJ5ABFYKYST5YM7DA', secretAccessKey: '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', region: 'us-east-1'
})

window._ = require('lodash')
window.axios = require('axios')
Vue.config.productionTip = false

var userLang = navigator.language || navigator.userLanguage || 'en'
Vue.component('NavBar', require('./components/NavBar.vue'))
Vue.component('regularDatalist', require('./components/regularDatalist.vue'))
Vue.component('regularFilter', require('./components/module/regularFilter.vue'))
Vue.component('v-map', Vue2Leaflet.Map)
Vue.component('v-tilelayer', Vue2Leaflet.TileLayer)
Vue.component('v-marker', Vue2Leaflet.Marker)
Vue.component('v-circle', Vue2Leaflet.LCircle)
Vue.component('v-popup', Vue2Leaflet.Popup)

Vue.use(vuexI18n.plugin, store)
Vue.use(VueFire)
Vue.i18n.add('en', translationsEn)
Vue.i18n.add('fr', translationsFr)
userLang.slice(0, 2) === 'fr' || userLang.slice(0, 2) === 'en' ? Vue.i18n.set(userLang.slice(0, 2)) : Vue.i18n.set('en')
sync(store, router)
/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Firebase.auth().currentUser) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

const unsubscribe = Firebase.auth().onAuthStateChanged(async (user) => {
  store.commit('setUser', user || false)
  if (user !== null) {
    let authorize
    await db.ref('users/transportersman').child(user.uid).once('value').then((snapshot) => {
      snapshot.val() === null ? authorize = false : authorize = true; store.commit('setAuthorization', snapshot.val())
    })
    if (!authorize) {
      Firebase.auth().signOut().then(() => {
        store.commit('clearUser')
        store.commit('clearContacts')
      }).catch(() => {})
      return router.push({path: '/login'})
    }
    db.ref('users/transporters').child(store.state.authorization.company).once('value').then((snapshot) => {
      store.commit('setUserInfo', snapshot.val() || false)
      if (snapshot.val().language === undefined || snapshot.val().language === '') Vue.i18n.set('en')
      else Vue.i18n.set(snapshot.val().language)
      if (!snapshot.val().isSageOne) store.commit('initAllContact')
    })
    // if (user.uid !== 'e58ff614-8449-4c3e-90b8-b42a48c2972b') store.commit('initAllContact')
  }
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
  unsubscribe()
})



// WEBPACK FOOTER //
// ./src/main.js